<template>
 <div class="panel panel-grid-item" :class="{'bg-slate-300': editable , 'bg-white': !editable}">
    <!-- Iconos acciones -->
    <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
    <div
      :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
      @click="onClickEliminar()"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-up': !collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(true)"
    ></div>
    <div
      :class="{ 'vue-collapsable-handle glyphicon glyphicon-chevron-down': collapsed && !editable }"
      style="color: #4d4d4d !important;"
      @click="cambiarCollapsed(false)"
    ></div>
    <!-- //Iconos acciones -->
    <!-- Modo editando -->
    <div class=" bg-slate-300" style="height: 100%;" v-if="editable && !collapsed">
      <span :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }">Venta Neta</span>
    </div>
    <!-- Modo editando -->
    
    <div class="" v-if="!editable && !collapsed">
      <span class="titulo-colapsado">Venta Neta</span>
    </div>
    <!-- Modo colapsado -->
    <div
      v-else
      class=""
      :class="{'pointer' : !editable}"
      @click="!editable ? cambiarCollapsed(false) : null"
    >
      <span
        :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }"
      >Venta Neta</span>
    </div>
    <!-- //Modo colapsado -->
    <div v-if="!editable && !collapsed" class="mt-2">
      <b-row>
        <b-col sm="6" md="6">
          <v-select
             v-model="vcomboValor"
            :items="comboValor"
            item-value="id"
            item-text="name"
            hide-details
            solo
            attach
            @change="actualizarTabla()"
          ></v-select>
        </b-col>
        <b-col sm="6" md="6">
          <v-select
            v-model="vcomboTiempo"
            :items="comboTiempo"
            item-value="id"
            item-text="name"
            value="Hoy"
            hide-details
            solo
            attach
            @change="actualizarTabla()"
          ></v-select>
        </b-col>
        <b-col cols="12" sm="12" class="columna-content mt-2">
          <v-data-table
            :headers="headers"
            :items="datosTabla"
            :sort-by="['tienda']"
            hide-actions
            :items-per-page= "100000"
            :mobile-breakpoint = "365"
            :loading = cargando
            class="elevation-5"
            style="overflow: auto"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-center">{{ props.item.tienda }}</td>
                <td v-if="vcomboValor === 1" class="text-xs-right">{{ props.item.unidades }}</td>
                <td v-else class="text-xs-right">{{ formatNum(props.item.valor) }}€</td>
                <td :class="getColor(props.item)" v-if="vcomboValor === 1" class="text-xs-right">{{ props.item.unicomp }}</td>
                <td :class="getColor(props.item)" v-else class="text-xs-right">{{ formatNum(props.item.valorcomp) }}€</td>
                <td :class="getColor(props.item)" v-if="vcomboValor === 1" class="text-xs-right">{{ props.item.porcentajeUni }}%</td>
                <td :class="getColor(props.item)" v-else class="text-xs-right">{{ props.item.porcentajeValor }}%</td>
                <td class="text-center"><v-chip :color="getColor(props.item)">{{ props.item.semaforo }}</v-chip></td>
              </tr>
            </template>
            <template v-slot:footer>
              <tr class="totales">
                  <td class="text-center">TOTAL</td>
                  <td class="text-xs-right">{{totalValor}}</td>
                  <td class="text-xs-right">{{totalComp}}</td>
                  <td class="text-xs-right">{{totalPorc}}%</td>
                  <td class="text-center"><v-chip :color="totalSem"></v-chip></td>
              </tr>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true">
                No hay datos
              </v-alert>
            </template>
          </v-data-table>
        </b-col>
      </b-row>
    </div>
 </div>
</template>
<script>
import { PsApiService } from '@/api/PsApiService'
import { Util } from '@/api/Util'

const psApiService = new PsApiService()
const util = new Util()

export default {
  props: {
    data: Object,
    config: Object,
    editable: Boolean,
    collapsed: Boolean,
    altura: Number,
    id: Number,
    refrescar: Number
  },
  data () {
    return {
      cargando: false,
      vcomboValor: 2,
      comboValor: [
        {
          id: 1,
          name: 'Unidades'
        },
        {
          id: 2,
          name: 'Valor'
        }
      ],
      vcomboTiempo: 1,
      comboTiempo: [
        {
          id: 1,
          name: 'Ayer'
        },
        {
          id: 2,
          name: 'Hoy'
        },
        {
          id: 3,
          name: 'Semana'
        },
        {
          id: 4,
          name: 'Mes'
        },
        {
          id: 5,
          name: 'Año'
        }
      ],
      datosTabla: [],
      vcomboTipoTienda: '--',
      comboTipoTienda: []

    }
  },
  computed: {
    // a computed getter
    headers: function () {
      if (this.vcomboValor === 1) {
        return [
          {
            text: 'Tienda',
            align: 'center',
            sortable: true,
            value: 'tienda'
          },
          { text: `${this.comboTiempo[this.vcomboTiempo - 1].name}`, sortable: true, value: 'unidades', align: 'right' },
          { text: 'Comparativa', sortable: true, value: 'unicomp', align: 'right' },
          { text: '%', value: 'porcentajeUni', align: 'right' },
          { text: 'Semaforo', sortable: false, value: 'semaforo', align: 'center' }
        ]
      } else {
        return [
          {
            text: 'Tienda',
            align: 'center',
            sortable: true,
            value: 'tienda'
          },
          { text: `${this.comboTiempo[this.vcomboTiempo - 1].name}`, sortable: true, value: 'valor', align: 'right' },
          { text: 'Comparativa', sortable: true, value: 'valorcomp', align: 'right' },
          { text: '%', value: 'porcentajeValor', align: 'right' },
          { text: 'Semaforo', sortable: false, value: 'semaforo', align: 'center' }
        ]
      }
    },
    regenerar () {
      return this.$store.getters.isRegenerarTablas
    },
    totalValor () {
      if (this.datosTabla.length) {
        let sum
        if (this.vcomboValor === 1) {
          sum = this.datosTabla.map(item => item.unidades).reduce((prev, next) => prev + next)
        } else {
          sum = this.datosTabla.map(item => item.valor).reduce((prev, next) => prev + next)
          sum = sum.toLocaleString(undefined, { minimumFractionDigits: 0 }) + '€'
        }
        return sum
      } else {
        return 0
      }
    },
    totalComp () {
      if (this.datosTabla.length) {
        let sum
        if (this.vcomboValor === 1) {
          sum = this.datosTabla.map(item => item.unicomp).reduce((prev, next) => prev + next)
        } else {
          sum = this.datosTabla.map(item => item.valorcomp).reduce((prev, next) => prev + next)
          sum = sum.toLocaleString(undefined, { minimumFractionDigits: 0 }) + '€'
        }
        return sum
      } else {
        return 0
      }
    },
    totalPorc () {
      if (this.datosTabla.length) {
        let sum, sum2, porcentaje

        if (this.vcomboValor === 1) {
          sum = this.datosTabla.map(item => item.unidades).reduce((prev, next) => prev + next)
          sum2 = this.datosTabla.map(item => item.unicomp).reduce((prev, next) => prev + next)
        } else {
          sum = this.datosTabla.map(item => item.valor).reduce((prev, next) => prev + next)
          sum2 = this.datosTabla.map(item => item.valorcomp).reduce((prev, next) => prev + next)
        }
        porcentaje = Math.round((sum2 / sum) * 100)
        return porcentaje
      } else {
        return 0
      }
    },
    totalSem () {
      if (this.datosTabla.length) {
        let sum
        if (this.vcomboValor === 1) {
          sum = this.datosTabla.map(item => item.unicomp).reduce((prev, next) => prev + next)
          if (sum < 0) return 'rojo'
          else if (sum === 0) return 'naranja'
          else return 'verde'
        } else {
          sum = this.datosTabla.map(item => item.valorcomp).reduce((prev, next) => prev + next)
          if (sum < 0) return 'rojo'
          else if (sum === 0) return 'naranja'
          else return 'verde'
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    // asyncronamente cargamos los datos de nuevo cuando ha acabado la procedure
    regenerar (value) {
      console.log(`My store value for 'regenerar' changed to ${value}`)
      this.actualizarTabla()
    },
    refrescar (value) {
      this.actualizarTabla()
    }
  },
  methods: {
    // handleScroll (event) {
    //   // Any code to be executed when the window is scrolled
    //   // Get the header
    //   var header = document.getElementsByClassName('v-data-table-header')

    //   // Get the offset position of the navbar
    //   var sticky = header[0].offsetHeight + 80
    //   // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    //   if (window.pageYOffset > sticky) {
    //     header[0].classList.add('sticky')
    //   } else {
    //     header[0].classList.remove('sticky')
    //   }
    // },
    onClickEliminar() {
      if (this.id != undefined) {
        this.$emit("eliminarventaneta", this.id);
      }
    },
    cambiarCollapsed(value) {
      let collapseOptions = {};
      collapseOptions.collapse = value;
      collapseOptions.id = this.id;
      collapseOptions.tipo = this.config.tipo;
      collapseOptions.altura = this.altura;
      this.$emit("collapse", collapseOptions);
    },
    formatNum (numero) {
      if (numero !== undefined) {
        return numero.toLocaleString(undefined, { minimumFractionDigits: 0 })
      } else {
        return null
      }
    },
    getColor (item) {
      if (this.vcomboValor === 1) {
        if (item.unicomp < 0) return 'rojo'
        else if (item.unicomp === 0) return 'naranja'
        else return 'verde'
      } else {
        if (item.valorcomp < 0) return 'rojo'
        else if (item.valorcomp === 0) return 'naranja'
        else return 'verde'
      }
    },
    actualizarTabla () {
      this.cargando = true
      psApiService
        .getVentaNeta(this.vcomboTiempo, this.vcomboTipoTienda)
        .then(data => {
          if (data !== "") {
            this.datosTabla = data
          } else {
            this.datosTabla = []
          }
          this.cargando = false
        })
        .catch(error => {
          util.mostrarEnConsola(
            'getVentaNeta',
            error,
            'ERROR'
          )
          this.datosTabla = []
          this.cargando = false
        })
    },
    getAllTipoTiendaVenta () {
      this.comboTipoTienda = []
      this.comboTipoTienda.push({ id: '--', name: 'Todas' })
      psApiService
        .getAllTipoTiendaVenta()
        .then(data => {
          for (var i = 0; i < data.length; i++) {
            this.comboTipoTienda.push(data[i])
          }
          util.mostrarEnConsola(
            'getAllTipoTiendaVenta',
            data.length,
            'OK'
          )
          this.vcomboTipoTienda = '--'
          this.actualizarTabla()
        })
        .catch(error => {
          util.mostrarEnConsola('getAllTipoTiendaVenta', error, 'ERROR')
          this.vcomboTipoTienda = '--'
          this.actualizarTabla()
        })
    },
     cambioTitulo() {
      this.$store.state.tituloIcono = '<i class="icon-user-tie"></i>'
      this.$store.state.titulo = 'Venta neta'
    }
  },
  created () {
    this.getAllTipoTiendaVenta()
    this.cambioTitulo()
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>
